import assert from '@banking/ui/utils/assert';
import { nonNullable } from './predicates';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import getPostalCodeFormatter from '@banking/ui/utils/field-kit-formatters/postal-code';
export const formatAddress = address => {
  const {
    addressLine1,
    addressLine2,
    locality,
    administrativeDistrictLevel1,
    postalCode,
    countryCode
  } = address;
  assert(nonNullable(addressLine1) && addressLine1.length > 0, 'addressLine1 is either empty or undefined');
  assert(nonNullable(locality) && locality.length > 0, 'locality is either empty or undefined');
  assert(nonNullable(administrativeDistrictLevel1) && administrativeDistrictLevel1.length > 0, 'administrativeDistrictLevel1 is either empty or undefined');
  assert(nonNullable(postalCode) && postalCode.length > 0, 'postalCode is either empty or undefined');
  const formattedPostalCode = getPostalCodeFormatter(countryCode).format(postalCode);
  const lastFormattedAddressLine = `${locality}, ${administrativeDistrictLevel1} ${formattedPostalCode}`;
  if (addressLine2 != null && addressLine2.length > 0) {
    return [addressLine1, addressLine2, lastFormattedAddressLine];
  }
  return [addressLine1, lastFormattedAddressLine];
};
export const addressEntry = (address, options) => {
  const label = [address.addressLine1, address.addressLine2].filter(nonNullable).join(' ');
  const countryCodeString = Country[address.countryCode];
  const formattedPostalCode = getPostalCodeFormatter(address.countryCode).format(address.postalCode);
  let subtext = `${address.locality}, ${address.administrativeDistrictLevel1} ${formattedPostalCode}`;
  if (!options?.hideCountryCode) {
    subtext += ` ${countryCodeString}`;
  }
  return {
    label,
    subtext
  };
};